import { isWechatBrowser } from '@/utils/wechat'

const protocol = process.env.VUE_APP_HTTP_SSL === 'true' ? 'https' : 'http'
const wxProxyUrl = `${protocol}://${process.env.VUE_APP_BACKSTAGE_REDIRECT_URI}?redirect_to=`
const wxShareUrl = `${protocol}://${process.env.VUE_APP_WX_JS_LINK}`
const wxPayENV = isWechatBrowser() ? 'H5' : 'NATIVE'

export {
  wxProxyUrl,
  wxShareUrl,
  wxPayENV
}
